/** Editorial marquee strip. CSS-only infinite scroll, pauses on hover. */
export const Marquee = ({ text = "Our Youth. Our Plan. Our Football.", repeat = 6, testId = "marquee" }) => {
  const items = Array.from({ length: repeat });
  return (
    <div
      className="group relative overflow-hidden border-y border-white/10 bg-black py-5 md:py-7"
      data-testid={testId}
    >
      <div className="marquee-track flex w-max items-center gap-10 group-hover:[animation-play-state:paused]">
        {items.map((_, i) => (
          <span key={i} className="flex shrink-0 items-center gap-10">
            <span className="wordmark text-stroke text-4xl uppercase leading-none md:text-6xl">{text}</span>
            <span className="h-3 w-3 shrink-0 rotate-45 bg-maasai" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
};
